import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useStore } from '../store';
import { AuthError } from '../lib/auth';
import { AuthShell, AuthBanner, Field } from '../components/AuthShell';

export function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const signIn = useStore((s) => s.signIn);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const from = (location.state as { from?: string } | null)?.from ?? '/apps';

  const submit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await signIn(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      const msg = err instanceof AuthError ? err.message : 'Sign in failed. Please try again.';
      setError(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      title="Sign in"
      subtitle="Welcome back to App Factory."
      footer={
        <span className="muted">
          Need an account? <Link to="/register">Create one</Link>
        </span>
      }
    >
      {error && <AuthBanner kind="error">{error}</AuthBanner>}
      <form onSubmit={submit}>
        <Field label="Email" type="email" value={email} onChange={setEmail} autoComplete="email" required autoFocus />
        <Field label="Password" type="password" value={password} onChange={setPassword} autoComplete="current-password" required />
        <button type="submit" className="btn btn--accent" disabled={busy} style={{ width: '100%', height: 38 }}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
      <div style={{ marginTop: 14, textAlign: 'center' }}>
        <Link to="/forgot-password" className="muted" style={{ fontSize: 13 }}>
          Forgot password?
        </Link>
      </div>
    </AuthShell>
  );
}
